import detectMobileDevice from 'is-mobile';
import React from 'react';
import styled, { css } from 'styled-components';

import { useConfig } from '../../hooks';
import MenuButton from './MenuButton';
import renderTitle from './renderTitle';

const Title = styled.div`
  padding: 0;
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  overflow-wrap: anywhere;
  color: ${props => props.textColor};

  p,
  h2,
  h3,
  h4,
  h5,
  h6 {
    padding: 0;
    margin: 0;
  }

  @media screen and (min-width: 768px) {
    line-height: 20px;
  }
`;

// eslint-disable-next-line import/prefer-default-export
export const CaptionClassic = () => {
  const isMobile = detectMobileDevice();
  const { fontFamily, header, headerMenu } = useConfig();

  if (!header.title) {
    return;
  }

  return (
    <Root
      fontFamily={fontFamily}
      color={header.title.color}
      isAvatar={header.avatar.enabled && !isMobile}
      flexBasis={header.avatar.offset.x}
    >
      {headerMenu?.enabled ? <MenuButton /> : ''}
      {renderTitle(header.title, Title)}
    </Root>
  );
};

const Root = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  min-height: 20px;
  margin-right: 20px !important;
  font-family: ${props => props.fontFamily};
  color: ${props => props.color};
  ${({ isAvatar }) => {
    if (isAvatar) {
      return css`
        flex: 0 0 ${props => props.flexBasis}px;
      `;
    }

    return css`
      flex: 1 0;
    `;
  }}

  @media screen and (min-width: 768px) {
    margin-right: 40px !important;
  }
`;
